export default __webpack_public_path__ + "static/media/processing.b6770070.svg";